import { httpService } from './HttpService';
import IGenericService from '../interfaces/IGenericService';

export default class GenericService<T> implements IGenericService<T> {
    constructor(public entity: string) {

    }

    public getAll(): Promise<Array<T>>  {
        return httpService.get(this.entity);
    }

    public getAllPaged(queryString: string = ""): Promise<Array<T>>  {
        return httpService.get(this.entity+queryString);
    }

    public getById(id: number): Promise<T> {
        return httpService.get(this.entity+"/"+id);
    }

    public insert(obj: T): Promise<T> {
        return httpService.post(this.entity, obj)
    }

    public update(obj: T): Promise<T> {
        return httpService.put(this.entity, obj)
    }

    public deleteById(id: number): Promise<any> {
        return httpService.delete(this.entity+"/"+id);
    }
}